import {isNumber} from 'lodash';
import {useMemo} from 'react';

import {Icon, IconName, NetworkQuality} from 'components';
import {VideoPinParticipant} from 'enums';

type Props = {
    participant?: VideoPinParticipant;
    participantId?: string;
    pinnedParticipant?: VideoPinParticipant;
    pinnedParticipantId?: string;
    networkQualityLevel?: number;
    videoPinEnabled?: boolean;
    participantName?: string;
    onVideoPinParticipantUpdate?: (p: VideoPinParticipant, participantId?: string) => void;
}

export const VideoOverlayContent: React.FC<Props> = ({
    participant, participantId, pinnedParticipant, pinnedParticipantId, networkQualityLevel, videoPinEnabled, participantName,
    onVideoPinParticipantUpdate
}) => {
    const isParticipantPinned = useMemo(() => {
        if (participantId) {
            return participantId === pinnedParticipantId;
        }
        return participant === pinnedParticipant;
    }, [participant, participantId, pinnedParticipant, pinnedParticipantId]);

    const iconName: IconName = useMemo(() => isParticipantPinned ? 'unpin' : 'pin', [isParticipantPinned]);
    const isVisible = useMemo(() => isNumber(networkQualityLevel) || videoPinEnabled || participantName,
        [networkQualityLevel, videoPinEnabled, participantName]);

    const handlePinClick = () => {
        if (onVideoPinParticipantUpdate) {
            onVideoPinParticipantUpdate(participantId ? null : participant, participantId);
        }
    };

    return isVisible ? (
        <div className='tw-absolute tw-inset-0 tw-z-10'>
            {(participantName || isNumber(networkQualityLevel)) &&
                <div className='
                    tw-absolute tw-top-2 tw-left-2 tw-bg-dark tw-bg-opacity-70
                    tw-px-2 tw-py-1 tw-rounded tw-flex tw-items-center tw-space-x-2 tw-max-w-[calc(100%-1rem)]
                '
                >
                    {participantName && <div className='tw-text-light tw-text-sm tw-truncate'>{participantName}</div>}
                    {isNumber(networkQualityLevel) && <NetworkQuality value={networkQualityLevel} />}
                </div>}
            {videoPinEnabled &&
                <div className='
                    tw-absolute tw-top-1/2 tw-left-1/2 tw--translate-x-1/2 tw--translate-y-1/2 tw-bg-dark tw-bg-opacity-30
                    tw-px-8 tw-py-2 tw-rounded-full
                '
                >
                    <div className='tw-bg-light tw-rounded-full tw-p-2 tw-bg-opacity-100'>
                        <Icon name={iconName} button color='default' onClick={handlePinClick} />
                    </div>
                </div>}
        </div>
    ) : null;
};